import React, { useEffect, useState } from 'react';

import DoughnutChart from '@components/charts/Doughnut';
import CustomTooltip, { POSITIONS } from '@components/CustomTooltip';

import { getShortName, processTrendResearchDecimalValues, trendResearchColorSchema } from '@utils/Util';

const TrendResearchDoughnutChart = ({ title, dataSet = {} }) => {
	const [chartDataSet, setChartDataSet] = useState({});

	useEffect(() => {
		if (Object.keys(dataSet).length > 0) {
			let others = dataSet.others;
			if (others) {
				let cloneObj = { ...dataSet };
				delete cloneObj.others;
				let processedData = processTrendResearchDecimalValues(cloneObj);
				let totalSum = 0;
				for (let item in processedData) {
					totalSum += parseFloat(processedData[item]);
				}
				let result = { ...processedData, others: parseFloat((100 - totalSum).toFixed(1)) };
				setChartDataSet(result);
			} else {
				let data = processTrendResearchDecimalValues(dataSet);
				setChartDataSet(data);
			}
		}
	}, [dataSet]);

	return (
		<div className="product-chart-box radius-4">
			<div className="chart-header">
				<p className="regular-14 weight-500 gray_dark_01">{title}</p>
			</div>
			<div className="chart-body m-auto text-center h-100">
				<div className="d-flex align-items-center h-100">
					<div className="m-auto text-center chart-canvas">
						<DoughnutChart
							isShowPercentage={false}
							aspectRatio={1}
							chartData={{
								labels: Object.keys(chartDataSet),
								datasets: [
									{
										data: Object.values(chartDataSet),
										backgroundColor: trendResearchColorSchema,
										hoverBackgroundColor: trendResearchColorSchema
									}
								]
							}}
						/>
					</div>
					<div className="chart-category">
						{Object.keys(chartDataSet).map((item, idx) => (
							<div className="chart-list d-flex align-items-center" key={`chart_label_${idx}`}>
								<div className="dot-and-name d-flex align-items-center">
									<span
										className="dots"
										style={{ backgroundColor: trendResearchColorSchema[idx] }}
									/>
									<span className="cate-name regular-14 gray_dark_02 weight-500">
										<CustomTooltip
											text={item}
											position={POSITIONS.BOTTOM}
											arrowCenter={true}
											className="custom-tooltip"
										>
											{getShortName(item, 12)}
										</CustomTooltip>
									</span>
								</div>
								<span className="regular-14 gray_dark_01 weight-500">
									{chartDataSet[item]}%
								</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default TrendResearchDoughnutChart;
